<template>
    <div class="user-search">
        <div class="user-search__header wrapper">
            <UserSearchHeader
                :total-count="totalCount"
                without-margin
            />
        </div>
        <div
            class="user-search__tabs"
            :class="{'user-search__tabs--margin--small' : !totalCount}"
        >
            <div class="wrapper wrapper--no-padding">
                <UserSearchTabs
                    :tabs="tabs"
                    @change-tab="changeTab"
                />
            </div>
        </div>
        <div v-if="userId" class="user-search__main wrapper wrapper--no-padding">
            <component
                :is="currentShownComponent"
                :isFavorite="isFavorite"
                :with-drafts="withDrafts"
                @total-count="setTotalCount"
            ></component>
        </div>
    </div>
</template>

<script>
import ListHeader from "@/components/UI/list-header/ListHeader.vue";
import UserSearchTabs from  "@/components/user-search/UserSearchTabs.vue";
import UserSearchList from "@/components/user-search/UserSearchList.vue";
import UserSearchFavorites from "@/components/user-search/UserSearchFavorites.vue";
import UserSearchGeneralStatistics from "@/components/user-search/UserSearchGeneralStatistics.vue";
import UserSearchProjectStatistics from "@/components/user-search/UserSearchProjectStatistics";
import UserSearchEducationStatistics from "@/components/user-search/UserSearchEducationStatistics";
import UserSearchHeader from "@/components/user-search/UserSearchHeader.vue";
import { userSearchTabsList } from "@/consts/userSearch";
import {mapGetters} from "vuex";

export default {
    name: 'UserSearchPage',

    components: {
        ListHeader,
        UserSearchTabs,
        UserSearchList,
        UserSearchFavorites,
        UserSearchGeneralStatistics,
        UserSearchProjectStatistics,
        UserSearchEducationStatistics,
        UserSearchHeader,
    },
    data() {
        return {
            currentShownComponent: "UserSearchList",
            tabs: userSearchTabsList,
            totalCount: 0,
            isFavorite: false,
            withDrafts: true,
            isSocialLifts: false,
            currentTab: null,
            routeSearchQueryString: null,
            routeFavoriteQueryString: null,
        };
    },
    methods: {
        changeTab(newComponent) {
            if(newComponent.isFavorite) {
              this.routeSearchQueryString = this.$route.query;
              this.$router.push({name: 'favorites', params: {...this.$route.params, noRouteChange: true}, query: this.routeFavoriteQueryString}).catch(err => {});
            } else if(newComponent.isGeneralStatistics) {
              this.routeFavoriteQueryString = this.$route.query;
              this.$router.push({name: 'general-statistics', params: {...this.$route.params, noRouteChange: true}, query: this.routeSearchQueryString}).catch(err => {});
            } else if(newComponent.isProjectStatistics) {
              this.routeFavoriteQueryString = this.$route.query;
              this.$router.push({name: 'project-statistics', params: {...this.$route.params, noRouteChange: true}, query: this.routeSearchQueryString}).catch(err => {});
            }else if(newComponent.isEducationStatistics) {
              this.routeFavoriteQueryString = this.$route.query;
              this.$router.push({name: 'education-statistics', params: {...this.$route.params, noRouteChange: true}, query: this.routeSearchQueryString}).catch(err => {});
            } else {
              this.routeFavoriteQueryString = this.$route.query;
              this.$router.push({name: 'account-user-search', params: {...this.$route.params, noRouteChange: true}, query: this.routeSearchQueryString}).catch(err => {});
            }
            this.currentShownComponent = newComponent.component;
            this.isFavorite = newComponent.isFavorite;

        },
        setTotalCount(totalCount) {
            this.totalCount = totalCount;
        },
    },
    computed: {
        ...mapGetters('auth', [
            'getUserRoles',
            'userId',
        ]),
    },

    watch: {

    },

    async created() {
        const hasAccess = [
            'ROLE_ADMIN',
            'ROLE_USER_ADMIN_READ_ONLY',
            'ROLE_USER_ADMIN_READ_ONLY_NO_CONTACTS',
        ].some(el => this.getUserRoles.includes(el));
        if(this.$route.name === 'favorites') {
          userSearchTabsList.forEach((tab, index) => {
            if(tab.component === "UserSearchFavorites") {
              this.currentShownComponent = tab.component;
              this.isFavorite = tab.isFavorite;
              tab.isActive = true;
            } else {
              tab.isActive = false;
            }
          });
        } else if (this.$route.name === 'general-statistics') {
          userSearchTabsList.forEach((tab, index) => {
            if(tab.component === "UserSearchGeneralStatistics") {
              this.currentShownComponent = tab.component;
              tab.isActive = true;
            } else {
              tab.isActive = false;
            }
          });
        } else if (this.$route.name === 'project-statistics') {
          userSearchTabsList.forEach((tab, index) => {
            if(tab.component === "UserSearchProjectStatistics") {
              this.currentShownComponent = tab.component;
              tab.isActive = true;
            } else {
              tab.isActive = false;
            }
          });
        } else if (this.$route.name === 'education-statistics') {
          userSearchTabsList.forEach((tab, index) => {
            if(tab.component === "UserSearchEducationStatistics") {
              this.currentShownComponent = tab.component;
              tab.isActive = true;
            } else {
              tab.isActive = false;
            }
          });
        }

        if (!hasAccess) {
            this.$router.push({ name: '404' });
        }
    },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/rem";

.user-search {
    background-color: #fff;
    font-family: 'Montserrat', sans-serif;
    display: grid;
    justify-items: center;
    row-gap: rem(40);
    padding: rem(36) 0px rem(96) 0px;

    @include on-desktop {
        padding: 0 0 urem(60) 0;
    }

    .wrapper {
        padding: mrem(14) mrem(14) 0 mrem(14);
        @include on-desktop {
            padding: 0;
            width: rem(1608);
        }

        &--no-padding {
            padding: 0;
            width: rem(1608);
        }
    }

    &__tabs {
        display: flex;
        justify-self: start;
        justify-content: center;
        width: 100%;
        background-color: #F8F8F8;

        @include on-desktop {
            margin-top: urem(160);

            &--margin {
                &--small {
                    margin-top: urem(90);
                }
            }
        }
    }
}
</style>
